import { DashboardGetFilteredProjectsQuery } from 'graphql/codegen/graphql';
import { ProjectRolesEnum, ArrayElement } from 'graphql/types';

export const getEmployeeByRole = (
  data: ArrayElement<DashboardGetFilteredProjectsQuery['masters']>,
  role: ProjectRolesEnum,
) => data?.projectRole?.find(projectRole => projectRole.role.id === role);
